export default __webpack_public_path__ + "static/media/wi_time-1.9efb6b1d.svg";